import React from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';

const Container = styled.div`
  padding-inline: 24px;
  padding-top: 24px;
  width: 100%;
`;

const Title = styled.span`
  font-weight: 600;
  font-style: SemiBold;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 30px;
  display: flex;
  justify-content: flex-start;
`;

const StepsContainer = styled.div`
  padding-top: 20px;
`;

const StepItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const StepTag = styled.div`
  height: 20px;
  width: 20px;
  border-radius: 20px;
  background-color: #dc0028;
  color: white;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

const StepText = styled.span`
  font-family: Arial;
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;
  margin-left: 10px;
  margin-bottom: 0px;
  flex: 1;
`;

interface ActivationStepsProps {
  steps?: string[];
  title?: string;
  msg?: string;
}

const ActivationSteps: React.FC<ActivationStepsProps> = ({
  steps,
  title,
  msg,
}) => {
  return (
    <Container>
      <Title>{title}</Title>

      <StepsContainer>
        {steps?.map((item, index) => (
          <StepItem key={index}>
            <StepTag>{index + 1}</StepTag>
            <Trans>
              <StepText>{item}</StepText>
            </Trans>
          </StepItem>
        ))}
      </StepsContainer>
    </Container>
  );
};

export default ActivationSteps;
